/**
 * Maximum number of invalid rows the large-import coercion review shows per
 * file. The review fetches exactly this many rows per file (offset 0) and shows
 * a truncation notice for any beyond it, so this window is the *reviewable*
 * working set — the only rows a user can inspect, edit, and apply.
 *
 * The resume probe (`hasStoredLargeImportCoercions` in `ReviewModal`) scans this
 * exact same window, so its "is there prior work to resume?" answer matches what
 * the review will actually render. The backend agent can also write proposals to
 * invalid rows beyond this window, but those rows are intentionally not
 * reviewable, so they must NOT count toward resume: resuming on them would drop
 * the user into a review whose visible rows have no proposals. Regenerating in
 * that case correctly re-populates proposals for the visible rows (the agent
 * re-derives them from the same value pool and the backend preserves any saved
 * `coercion_edits`). A persisted "agent has run" marker would be wrong here —
 * applying fixes deletes and rebuilds the analyzed rows (wiping proposals), so
 * the next invalid working set genuinely needs a fresh run; only a scan of the
 * current rows can tell that the proposals are gone.
 */
export const MAX_COERCION_ROWS = 500;
